import React from "react";

// material ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import SectionHeader from "../../components/SectionHeader";
import FormContainer from "../../components/FormContainer";

const styles = () => {
  return {};
};

const SaveChooser = (props) => {
  const goTo = (path) => {
    props.history.push(path);
  };
  return (
    <FormContainer headline={"Add News or Event"}>
      <SectionHeader
        label="What would you like to add?"
        gridProps={{ md: 12 }}
      />
      <Grid item md={12} style={{ display: "flex", gap: 16 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => goTo("/newsItem/news/add")}
          style={{ marginRight: 12 }}
        >
          Add News Item
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => goTo("/newsItem/event/add")}
        >
          Add Event
        </Button>
      </Grid>
    </FormContainer>
  );
};

export default withStyles(styles)(SaveChooser);
